import { Stack } from '@mui/material';

import { FTextArea } from '../../../../../../components/baseV2';
import { FormRichTextField } from '../../../../../common';
import { ASSESSMENT_SUMMARY_DSM5_FIELD_SX } from '../styles';

import type { AssessmentSummaryFieldsProps } from './types';

export default function AssessmentSummaryFields({
  formik,
  dsm5SymptomsText,
  disabled,
  readOnly,
  saveField,
  templates,
}: AssessmentSummaryFieldsProps) {
  return (
    <Stack gap={2}>
      <FormRichTextField
        disabled={disabled}
        formik={formik}
        label="Assessment results in terms of domains of deficit vs strengths"
        name="assessment_results"
        onBlur={saveField}
        placeholder="Describe the results in terms of domains of deficit vs strengths"
        readOnly={readOnly}
        required
        showTemplateButton
        templateValue={templates?.page.assessment_results}
      />
      <FTextArea
        disabled={disabled}
        fullWidth
        InputProps={{ readOnly: true }}
        label="Patient symptoms noted from DSM5 in assessment"
        minRows={1}
        placeholder="Auto entered data"
        sx={ASSESSMENT_SUMMARY_DSM5_FIELD_SX}
        value={dsm5SymptomsText}
      />
      <FormRichTextField
        disabled={disabled}
        formik={formik}
        label="Priorities/ goals based on assessment results"
        name="priorities"
        onBlur={saveField}
        placeholder="Describe priorities/ goals"
        readOnly={readOnly}
        required
        showTemplateButton
        templateValue={templates?.page.priorities}
      />
    </Stack>
  );
}
